<script>
import PortfolioCard from "@/components/PortfolioCard.vue";
export default {
  components: {PortfolioCard},
  data() {
    return {
      currentCategory: 'ALL',
    }
  },

  methods: {
    chooseCategory(newCategory) {
      this.currentCategory = newCategory;
    }
  }
}
</script>

<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <div id="portfolio">
    <h1 class="text-center normal-heading mb-3">Portfolio</h1>

<!--    <div class="btn-group my-5 mx-5">-->
<!--      <button type="button" @click="chooseCategory('ALL')" :class="{active: currentCategory === 'ALL' }"-->
<!--              class="btn btn-lg btn-primary mx-2">All</button>-->
<!--      <button type="button" @click="chooseCategory('SOFTWARE')" :class="{active: currentCategory === 'SOFTWARE' }"-->
<!--              class="btn btn-lg btn-primary mx-2">Software Projects</button>-->
<!--      <button type="button" @click="chooseCategory('EDUCATION')"-->
<!--              :class="{active: currentCategory === 'EDUCATION' }"-->
<!--              class="btn btn-lg btn-primary mx-2">Education</button>-->
<!--    </div>-->

    <div class="project-grid">
      <PortfolioCard translation-key="bookminecraft" img="book-minecraft.webp" fit="contain"
                     link="https://www.rheinwerk-verlag.de/lets-craft-code-wie-du-deine-minecraft-welt-mit-plugins-erweiterst/?GPP=schloool"/>
      <PortfolioCard translation-key="book" img="book.webp" fit="contain"
                     link="https://www.rheinwerk-verlag.de/spieleentwicklung-mit-unity_6400/?GPP=schloool"/>
<!--      <PortfolioCard translation-key="studisq" img="studisq.png" link="http://studisq.de/"/>-->
<!--      <PortfolioCard translation-key="deinplugin" img="deinplugin.png" link="https://deinplugin.net/"/>-->
      <PortfolioCard translation-key="hsmwmobil" img="hsmwmobil.webp" link="https://www.hs-mittweida.de/webs/hsmwmobil/funktionen"/>
      <PortfolioCard translation-key="ampguard" img="ampguard.webp" link="https://store.steampowered.com/app/1852660/Ampguard/"/>
      <PortfolioCard translation-key="schloool" img="schloool-yt.webp" link="https://www.youtube.com/channel/UCZXhOwVsAlawjxbnIcsIsAA"/>
      <PortfolioCard translation-key="bivieh" img="bivieh-yt.webp" link="https://www.youtube.com/channel/UCoZtjPCrPugVD9Q7Fb3tJ6w"/>
<!--      <PortfolioCard translation-key="webcongress" img="web-congress.jpg" link="https://webentwicklerkongress.de/"/>-->
      <PortfolioCard translation-key="lokallabore" img="lokallabore.webp" link="https://lokallabore.de/"/>
    </div>
  </div>

</template>

<style scoped>
.project-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 320px), 1fr));
  gap: 1.75rem;
  max-width: 1400px;
  margin: 0 auto 3rem;
  padding: 0 1.5rem;
}

@media only screen and (max-width: 575px) {
  .project-grid {
    gap: 1.25rem;
    padding: 0 1rem;
  }
}
</style>